import * as angular from 'angular';
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {GroupsRequestsService} from "./groups-requests.service";
import {GroupsAlertsService} from "./groups-alerts.service";
import {Settelment} from "../../contracts/models/settelment.model";
import {GroupModel} from "../models/group.model";

export class GroupsService {

  constructor(private groupsRequestsService: GroupsRequestsService, private groupsAlertsService: GroupsAlertsService,
              private bringozLoaderService: BringozLoaderService, private $log, private $q) {
  }

  createGroup(group: GroupModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.groupsRequestsService.createGroup(group)
      .then((group) => {
        this.groupsAlertsService.createSuccess();
        deferred.resolve(group);
      })
      .catch((error) => {
        this.$log.error(error);
        this.groupsAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  editGroup(group: GroupModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.groupsRequestsService.editGroup(group)
      .then((group) => {
        this.groupsAlertsService.editSuccess();
        deferred.resolve(group);
      })
      .catch((error) => {
        this.$log.error(error);
        this.groupsAlertsService.editError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getTotalGroups() {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.groupsRequestsService.getTotalGroups()
        .then((updatedBranch) => {
          resolve(updatedBranch);
        })
        .catch((error) => {
          this.$log.error(error);
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    })
  }

  deleteGroup(groupId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.groupsRequestsService.deleteGroup(groupId)
      .then((group) => {
        this.groupsAlertsService.deleteSuccess();
        deferred.resolve(group);
      })
      .catch((error) => {
        this.$log.error(error);
        this.groupsAlertsService.deleteError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  addBranchesToGroup(groupId: string, branchIds?: string[], branchQuery?: string, excludedBranchIds?: string[], tags?:string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.groupsRequestsService.addBranchesToGroup(groupId, branchQuery, branchIds, excludedBranchIds, tags)
      .then((group) => {
        this.groupsAlertsService.moveBranchesToGroupSuccess();
        deferred.resolve(group);
      })
      .catch((error) => {
        this.$log.error(error);
        this.groupsAlertsService.moveBranchesToGroupError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

}

angular
  .module('bringoz.admin.groups')
  .service('groupsService', GroupsService);
